<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4584 14.875L8.50008 11.3333L3.54175 14.875V3.54167C3.54175 3.16594 3.691 2.80561 3.95668 2.53993C4.22236 2.27426 4.58269 2.125 4.95841 2.125H12.0417C12.4175 2.125 12.7778 2.27426 13.0435 2.53993C13.3092 2.80561 13.4584 3.16594 13.4584 3.54167V14.875Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>